module.exports = __webpack_public_path__ + "img/ModularWallV7.b51bf042.jpg";